import React, { useEffect, useState } from "react";
import {
  countries,
  countries_en,
} from "../../../../utils/constants/nameCountry";
import { useCurrentLanguage } from "../../../../hooks/useCurrentLanguage";
import { getSurveyJSON } from "../../../../services/jsons";
import { TOOLTIP_STYLE } from "../../../../utils/constants/graphConfigs";
import CardSurveys from "../../../reusable/CardSurveys";

export default function Beliefs() {
  const { language } = useCurrentLanguage();

  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState();

  // Load graph data
  useEffect(() => {
    const getData = async () => {
      const response = await getSurveyJSON("beliefs");

      response.data.forEach((square) => (square[2] = square[2].toFixed(1)));

      setData(response);
      setIsLoading(false);
    };

    getData();
  }, []);

  useEffect(() => {
    if (!isLoading && data !== undefined) {
      const options = {
        title: {
          text:
            language === "en"
              ? "Percentage of population that agrees"
              : "Porcentaje de población que está de acuerdo",
          show: true,
          bottom: "0",
          left: "center",
          textStyle: {
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: "normal",
          },
        },
        tooltip: {
          // position: "right",
          ...TOOLTIP_STYLE,
          valueFormatter: (value) => value + "%",
          formatter: (props) => {
            return (
              "<span>" +
              (language === "en"
                ? countries_en[props.name]
                : countries[props.name]) +
              "</span>" +
              "<br/>" +
              props.value[2] +
              "%"
            );
          },
        },
        grid: {
          height: "80%",
          top: "0%",
          right: "2%",
          left: "130px",
          bottom: "50px",
        },
        xAxis: {
          type: "category",
          data: data.countries,
          splitArea: {
            show: true,
          },
        },
        yAxis: {
          type: "category",
          data: data.questions[language ?? "es"],
          splitArea: {
            show: true,
          },
          axisLabel: {
            width: "120",
            overflow: "break",
          },
        },
        visualMap: {
          min: 0,
          max: 100,
          calculable: true,
          orient: "horizontal",
          itemHeight: "350%",
          itemWidth: "15%",
          left: "center",
          bottom: "5%",
          inRange: {
            color: ["#eff5f8", "#305EA9"],
          },
        },
        series: [
          {
            name: "Beliefs",
            type: "heatmap",
            data: data.data,
            label: {
              show: false,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };

      setOptions(options);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, language]);

  return <CardSurveys isLoading={isLoading} options={options} />;
}
